import React, { useCallback, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

const Footer = ({ className, orderId }) => {
  const { t } = useTranslation('ModalOrderDetail');
  const dispatch = useDispatch();
  const location = window.location;

  const handlePrint = useCallback(() => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.shipperOrderPrint({ place: 'DETAIL', orderId })
      )
    );
    window.print();
  }, [dispatch, orderId]);

  // the url for this page is /orders/previous/123
  // in the shipments list, users can click on print directly
  // the url will be /orders/previous/123?print=true
  // with this effect we detect the URL param print
  // we will automatically call the print function
  // and then redirect to the same url withouth the print param, so it only runs 1
  useEffect(() => {
    if (location.search.includes('?print=true')) {
      const redirectURL = location.pathname;
      handlePrint();
      dispatch(push(redirectURL));
    }
  }, [handlePrint, location, dispatch]);

  return (
    <div className={className}>
      <div className="print-btn">
        <Button
          data-e2e="printButton"
          icon="printer"
          iconPosition="left"
          text={t('footer.print_button')}
          skin="white"
          ghost
          onClick={handlePrint}
        />
      </div>
    </div>
  );
};

Footer.propTypes = {
  orderId: PropTypes.string.isRequired,
};

export default Footer;
